<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  methods: {
  },
};
</script>

<style lang='less'>
#app {
  height: 100%;
  background: #f0f0f0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue